import { api } from 'api/api';
import { urls } from 'api/urls';

import type { ListarCidadesTypes } from './cidades.types';

const listarCidades = async (params: ListarCidadesTypes) => await api.get(`${urls.cidades}`, { params: params });

export { listarCidades };
